import React from 'react';

export function Logo({ endoso = false }) {
  return (
    <span className="row" style={{ gap: 8 }}>
      <span className="logo" aria-label="HUECO">
        HUEC<span className="hueco-sq" />
      </span>
      {endoso && <span className="muted small exp" style={{ fontWeight: 400 }}>by AGENTIK</span>}
    </span>
  );
}
